import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom'
import { AppLayout } from '../../layouts';
import { EbPageLoader } from '../Common';


const ReportList = lazy(() => import('.').then((module) => ({ default: module.ReportList })));

const ReportsRouter = (props) => {
    const AppRoute = props.AppRoute;
    return (
        <Switch>
            <Suspense fallback={<EbPageLoader />}>
                <AppRoute exact path="/reports" layout={AppLayout} component={ReportList} pathkey="reports" />
            </Suspense>
        </Switch>
    )
}

export { ReportsRouter };